import { Box, SimpleGrid, Text } from "@chakra-ui/react";

const AdminStats = ({ stats }) => {
  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={6} mb={8}>
      {stats.map((stat, index) => (
        <Box
          key={index}
          bg="white"
          p={4}
          rounded="lg"
          shadow="sm"
          borderLeft="4px solid"
          borderColor={stat.up ? "green.400" : "orange.400"}
        >
          <Text fontSize="sm" color="gray.600">
            {stat.label}
          </Text>
          <Text fontSize="2xl" fontWeight="bold">
            {stat.value ?? 0}
          </Text>
          {stat.trend && (
            <Text fontSize="sm" color={stat.up ? "green.500" : "red.500"}>
              {stat.trend}
            </Text>
          )}
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default AdminStats;
